const getServiceListStyles = () => ({
  position: 'relative'
});
const getLoadingStyles = () => ({
  display: 'flex',
  justifyContent: 'center'
});
const getChipListStyles = theme => ({
  overflowY: 'auto',
  flexWrap: 'nowrap',
  marginBottom: theme.spacing(1)
});
const getChipStyles = () => ({
  whiteSpace: 'nowrap'
});
const getServiceCardStyles = theme => ({
  ':nth-of-type(n + 2)': {
    marginTop: theme.spacing(3)
  }
});
const getSelectAndFiltersSectionStyles = (showFilters, sortingFeatureEnabled) => ({
  ...(showFilters && sortingFeatureEnabled && {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  })
});

export { getChipListStyles, getChipStyles, getLoadingStyles, getSelectAndFiltersSectionStyles, getServiceCardStyles, getServiceListStyles };
//# sourceMappingURL=ServiceListStyles.js.map
